import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { KameleoonService } from '@seven1/angular/kameleoon';
import { IOneDirectionContainerBlok } from './one-direction-container.model';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsComponent } from '@seven1/angular-storyblok-cms';

@Component({
    selector: 'app-one-direction-container',
    imports: [CmsComponent],
    templateUrl: './one-direction-container.component.html',
    host: { '[class]': 'getAllClasses()' },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneDirectionContainerComponent {
    private _tailwind = inject(TailwindService);
    private _kameleoon = inject(KameleoonService);
    private _route = inject(ActivatedRoute);
    private _queryParams = toSignal(this._route.queryParamMap);

    block = input.required<IOneDirectionContainerBlok>();

    visible = computed<boolean>(() => {
        return this._kameleoon.visible(this._queryParams(), this.block());
    });
    getAllClasses = computed<string[]>(() => {
        const blok = this.block();
        return [
            'flex',
            ...this._tailwind.getSpacingClasses(blok),
            ...this._tailwind.getFlexboxClasses(blok),
            ...this._tailwind.getDisplayClasses(blok, 'flex'),
        ];
    });
}
